
export const groupEditors = (editors) => ({
    $name: "grouped editor",
    valid: !editors.some((e) => {
        // if (!e.valid) {
        //     console.log("!e.valid", e);
        // }
        return !e.valid;
    }),
    loading: editors.some((e) => {
        // if (!e.valid) {
        //     console.log("!e.valid", e);
        // }
        return e.loading;
    }),
    changed: !!editors.some((e) => {
        // if (e.changed) {
        //     console.log("changed", e);
        // }
        return e.changed;
    }),
    prepareSave: (value) => {
        let onSaveds = [];
        for (const editor of editors) {
            if (!editor.prepareSave) {
                continue;
            }
            const result = editor.prepareSave(value);
            value = result.newValue;
            if (result.onSaved) {
                onSaveds.push(result.onSaved);
            }
        }
        return {
            newValue: value,
            onSaved: async (result) => {
                for (const onSaved of onSaveds) {
                    await onSaved(result);
                }
            },
        }
    },
    highlightErrors: () => editors.find((ie) => !ie.valid && ie.highlightErrors)?.highlightErrors(),
    errorsHandling: editors.find((ie) => !ie.valid && ie.errorsHandling)?.errorsHandling,
    showWarnings: async () => {
        for (const editor of editors) {
            if (editor.showWarnings && !await editor.showWarnings()) {
                return false;
            }
        }
        return true;
    },
});
